import { useCallback, useEffect, useState } from "react";
import config from "@/config";
import { useTranslation } from "react-i18next";
import { useEndUserSessionMutation } from "./user-api";
import { IUserState, setUser } from "./user-slice";
import { useDispatch, useSelector } from "react-redux";
import { useMsal } from "@azure/msal-react";
import { HEADER } from "@/appConstants";
import { MotifProgressLoader } from "@ey-xd/motif-react";
import {
  clearAuthenticatedUserContext,
  clearUserIdAndSessionIdCookies,
} from "@/ApplicationInsights/appInsights";
const { features } = config;

export default function AccessDenied() {
  const [success, setSuccess] = useState(false);
  const { accounts, inProgress } = useMsal();
  const [endUserSession] = useEndUserSessionMutation();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const user: IUserState = useSelector((state: any) => state.user);

  const handleLogout = useCallback(async () => {
    if (features.session) {
      await endUserSession();
    }

    if (accounts && accounts.length > 0 && inProgress === "none") {
      sessionStorage.removeItem("msal.login.request");
      clearUserIdAndSessionIdCookies();
      clearAuthenticatedUserContext();
    }
  }, [endUserSession, accounts, inProgress]);

  useEffect(() => {
    if (
      !success &&
      accounts &&
      accounts.length === 0 &&
      user.applicationAccess === false
    ) {
      const emptyUser: IUserState = {
        id: "",
        name: "",
        email: "",
        photo: undefined,
        accessToken: undefined,
        sessionActive: false,
      };
      dispatch(setUser(emptyUser));
      setTimeout(() => {
        setSuccess(true);
      }, 1000);
    }

    if (
      !success &&
      accounts &&
      accounts.length > 0 &&
      inProgress === "none" &&
      user.applicationAccess === false
    ) {
      handleLogout();
    }
  }, [dispatch, accounts, success, inProgress, handleLogout, user]);

  return (
    <>
      {user?.applicationAccess !== undefined ? (
        <div className="logout-container">
          <p className="motif-h1">
            {t("global.globalNotifications.accessDenied", {
              applicationHeading: HEADER.applicationNameInHeader,
            })}
          </p>
        </div>
      ) : (
        <div className="logout-container">
          <MotifProgressLoader />
        </div>
      )}
    </>
  );
}
